import type { WalletSliceKey } from '@/hooks/auth/types/wallet-slice.type';

export type AuthTokenRefreshListener = () => void;
export type AuthTokenUpdateMetadata = { walletType?: WalletSliceKey | null };
export type AuthTokenUpdateListener = (token: string | null, metadata: AuthTokenUpdateMetadata) => void;

let currentAuthToken: string | null = null;
const refreshListeners = new Set<AuthTokenRefreshListener>();
const updateListeners = new Set<AuthTokenUpdateListener>();

export function getCurrentAuthToken(): string | null {
	return currentAuthToken;
}

export function setCurrentAuthToken(token: string | null, options?: { walletType?: WalletSliceKey | null; silent?: boolean }) {
	currentAuthToken = token ?? null;
	if (!options?.silent) {
		notifyAuthTokenUpdated(currentAuthToken, { walletType: options?.walletType ?? null });
	}
}

export function clearCurrentAuthToken(options?: { walletType?: WalletSliceKey | null; silent?: boolean }) {
	currentAuthToken = null;
	if (!options?.silent) {
		notifyAuthTokenUpdated(null, { walletType: options?.walletType ?? null });
	}
}

export function subscribeAuthTokenRefresh(listener: AuthTokenRefreshListener) {
	refreshListeners.add(listener);
	return () => {
		refreshListeners.delete(listener);
	};
}

export function subscribeAuthTokenUpdates(listener: AuthTokenUpdateListener) {
	updateListeners.add(listener);
	return () => {
		updateListeners.delete(listener);
	};
}

export function requestAuthTokenRefresh() {
	for (const listener of [...refreshListeners]) {
		try {
			listener();
		} catch (error) {
			console.error('Auth token refresh listener failed', error);
		}
	}
}

function notifyAuthTokenUpdated(token: string | null, metadata: AuthTokenUpdateMetadata) {
	for (const listener of [...updateListeners]) {
		try {
			listener(token, metadata);
		} catch (error) {
			console.error('Auth token update listener failed', error);
		}
	}
}
